import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { protectionOrderApi } from "../../services/api";
import { useToast } from "./Toast/ToastProvider";
import "./ProtectionOrderModal.css";

export default function ProtectionOrderModal({
  car,
  carTitle,
  plans = [],
  orderConfig = {},
  onClose,
  onSuccess,
}) {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [planId, setPlanId] = useState(plans[0]?.id || "");
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const selectedPlan = plans.find((p) => p.id === planId) || plans[0];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedPlan) return;

    setSubmitting(true);
    try {
      await protectionOrderApi.create({
        carId: car.id || car._id,
        planId: selectedPlan.id,
        planName: selectedPlan.name,
        returnDays: selectedPlan.returnDays || 0,
        supportDays: selectedPlan.supportDays || 0,
        engineGearbox: Boolean(selectedPlan.engineGearbox),
        carPrice: car.price,
        notes,
      });
      showToast({
        type: "success",
        title: orderConfig.successTitle,
        message: orderConfig.successMessage,
      });
      onSuccess?.();
      onClose();
    } catch (err) {
      showToast({
        type: "error",
        title: orderConfig.errorTitle,
        message: err.message || orderConfig.errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="protection-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="protection-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="protection-modal-title"
      >
        <button type="button" className="protection-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <h2 id="protection-modal-title">{orderConfig.title}</h2>
        <p className="protection-modal-subtitle">{orderConfig.subtitle}</p>
        <p className="protection-modal-car">{carTitle}</p>

        <form onSubmit={handleSubmit}>
          <label className="protection-field-label">{orderConfig.planLabel}</label>
          <div className="protection-plan-options">
            {plans.map((plan) => (
              <button
                key={plan.id}
                type="button"
                className={`protection-plan-option ${planId === plan.id ? "active" : ""}`}
                onClick={() => setPlanId(plan.id)}
              >
                <strong>{plan.name}</strong>
                {plan.badge && <span className="plan-badge">{plan.badge}</span>}
                <small>
                  {plan.returnDays > 0 && `${plan.returnDays}-day return · `}
                  {plan.supportDays}-day support
                </small>
              </button>
            ))}
          </div>

          <label className="protection-field-label" htmlFor="protection-notes">
            {orderConfig.notesLabel}
          </label>
          <textarea
            id="protection-notes"
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder={orderConfig.notesPlaceholder}
          />

          <div className="protection-modal-actions">
            <button type="submit" className="protection-btn primary" disabled={submitting || !selectedPlan}>
              {submitting ? orderConfig.submittingLabel : orderConfig.submitLabel}
            </button>
            <button
              type="button"
              className="protection-btn ghost"
              onClick={() => navigate(orderConfig.policyPath || "/warranty")}
            >
              {orderConfig.policyLinkLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
